import React, {Fragment, useEffect, useState} from "react";
import {Button, Form, Spinner} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {useYupValidationResolver} from "../../../common";
import * as yup from "yup";
import {adminUpdateAccount} from "../../../api-service/account";
import {toast} from "react-toastify";

const validationSchema = yup.object({});

export function TabAccountComponent({
                                        accountInfo, onSubmit
                                    }) {
    const [isLoading, setLoading] = useState(false);
    const [accountDetail, setAccountDetail] = useState<any>(null);
    const resolver = useYupValidationResolver(validationSchema);
    const {
        register,
        control,
        handleSubmit,
        setValue,
        reset,
        getValues,
        watch,
        clearErrors,
        formState: {isSubmitting, isDirty, errors, isSubmitted}
    } = useForm({
        resolver: resolver,
        defaultValues: {
            useFaceRecognition: false,
            useAccessControl: false,
            useAttendanceApplication: false,
            disableCardSyncNotification: false,
        },
        mode: "onBlur",
        reValidateMode: "onChange"

    });

    useEffect(() => {
        console.log(accountInfo);
        let detail = accountInfo.detail;
        setAccountDetail(detail);
        reset({
            useFaceRecognition: detail?.useFaceRecognition ?? false,
            useAccessControl: detail?.useAccessControl ?? false,
            useAttendanceApplication : detail?.useAttendanceApplication ?? false,
            disableCardSyncNotification : detail?.disableCardSyncNotification ?? false,
        })
    }, [accountInfo,]);
    const submitFormData = async (data) => {
        const requestData = {
            ...data,
            AccountId: accountDetail.AccountId,
        }
        setLoading(true);
        await adminUpdateAccount(requestData).then((response: any) => {
            console.log(response);
            setLoading(false);
            toast.success("保存されました。");
            onSubmit();
        }).catch(err => {
            toast.error("保存処理に失敗しました。再度お試しください。");
            setLoading(false);
        });
    }

    return (
        <Fragment>
            <div className="tab-setting-account bg-white p-3">
                <Form onSubmit={handleSubmit(submitFormData)}>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            取引先ID
                        </Form.Label>
                        <div className="d-flex w-100 align-items-center">
                            <p className={"mb-0"}>{accountDetail?.AccountId}</p>
                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            取引先名
                        </Form.Label>
                        <div className="d-flex w-100 align-items-center">
                            <p className={"mb-0"}>{accountDetail?.AccountName}</p>

                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            顔認証
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useFaceRecognition`)}
                                />
                            </Form.Check>

                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            入退館連携
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useAccessControl`)}
                                />
                            </Form.Check>


                        </div>
                    </div>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            勤怠申請表示
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useAttendanceApplication`)}
                                />
                            </Form.Check>
                        </div>
                    </div>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            IDm同期通知しない
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`disableCardSyncNotification`)}
                                />
                            </Form.Check>
                        </div>
                    </div>

                    <div className="d-flex pt-3 justify-content-center">
                        {
                            isLoading ?
                                <Button size={'sm'} className="button-search" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    保存...
                                </Button>
                                :
                                <Button className="btn-detail btn btn-primary btn-sm" type={"submit"}>
                                    保存
                                </Button>
                        }
                    </div>

                </Form>
            </div>
        </Fragment>
    )

}